export const ImagePath = {
    logo: require("../assets/images/logo.png"),
    topLeftLogin: require("../assets/images/topLeftLogin.png"),
    bottomRightLogin: require("../assets/images/bottomRightLogin.png"),
    thanksGivingImage: require("../assets/images/thanksgiving.jpg"),
    noImageYet: require("../assets/images/NoImage.jpg")
}